var _rect, _text, _line, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTaxiDeLaDouce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 520,
    height: 120,
    viewBox: "0 0 520 120",
    role: "img",
    "aria-label": "Taxi de la Douce",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 62,
    fontFamily: "Georgia, 'Times New Roman', Times, serif",
    fontSize: 56,
    fontWeight: 700,
    fill: "#f0f0f0",
    letterSpacing: 0.5
  }, "\n    Taxi ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#d4af37"
  }, "de la Douce"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 84,
    x2: 420,
    y2: 84,
    stroke: "#d4af37",
    strokeWidth: 2,
    opacity: 0.85
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 108,
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 600,
    fill: "#f0f0f0",
    opacity: 0.9,
    letterSpacing: 0.2
  }, "\n    Votre trajet en toute distinction.\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTaxiDeLaDouce);
export default __webpack_public_path__ + "static/media/logo-taxi-de-la-douce.b8cb0b62cb75db059b82d4d788873ccc.svg";
export { ForwardRef as ReactComponent };